<template>
    <div class="page_home">
        <!-- nav -->
        <index-nav></index-nav>
        <!-- bottom -->
        <index-bottom></index-bottom>
        <div class="content">
            <!-- 轮播图 -->
            <div class="lunbo" v-if="homeInfo&&homeInfo.banner&&homeInfo.banner.length!=0">
                <div class="swiper mySwiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in homeInfo.banner" :key="'lun'+index">
                            <img :src="adddom(item.thumb)" alt />
                        </div>
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
            <!-- 公告 -->
            <!-- <div class="gong inner">
        <div class="icon">
          <img src="/statics/images/index/gonggao.png" alt />
        </div>
        <div class="gonggao">
          <span>[公告]：</span>
        </div>
        <marquee
          id="scrollarea"
          direction="up"
          scrolldelay="10"
          scrollamount="1"
          width="100%%"
          height="60"
          onmouseover="this.stop();"
          onmouseout="this.start();"
          style="height: 30px; margin: 5px 0;"
        >
          <ul>
            <li
              v-for="(item,index) in homeInfo.notice"
              :key="'gg'+index"
              @click="tonewsInfo(item.id)"
            >
              <span>{{item.title}}</span>
            </li>
          </ul>
        </marquee>
      </div> -->
            <!-- 公司介绍 -->
            <div class="introduce">
                <div class="inner">
                    <div class="top">
                        <div class="int_pic">
                            <img src="/statics/images/index/int_pic.png" alt />
                        </div>
                        <div class="int_center">
                            <span>客户满意为方向</span>
                            <span>产品质量为生命</span>
                        </div>
                        <div class="con" @click="toInfo">
                            <h3>亿兴隆通风设备（河北）有限公司</h3>
                            <div class="word">
                                <div class="fwb" v-html="homeInfo.about"></div>
                                <div class="sheng">...</div>
                            </div>
                            <!-- <p>
                坐落在朝气蓬勃的山东德州武城，武城是全国致力于新材料及空调、风机、风阀、消防、人防系列设备设计、开发、制造、销售、安装及技术服务于一体的现代化高科技集中生产基地，融科技、自然、人文、生态环境于一体，环境优美、交通便利、地理位置优越。
              </p>
              <p>
                德州润邦环保设备有限公司始建于2012年12月，在武城创建了生产基地，不仅拥有在新材料及工业空调领域中先进的生产设备和技术水平、高超的产品质量和性能，而且拥有较高的产品性能价格比，优质完美的客户服务与支持保障。
                目前公司主要产品有：人防过滤吸收器，手动密闭阀，脚踏两用风机，油网滤尘器，玻璃钢产品、轴流式消防排烟风机、离心式消防排烟风机、轴流式屋顶风机、离心式屋顶风机、各种玻璃钢风机、风机盘管、新风机组、新风换气机、防火阀、调节阀、铝合金风口及通风管道、净化设备、不锈钢铸造系列产品、电厂专用管道筒仓泄压装置、煤仓安全系统、给煤机、清堵机、锅炉酸洗、锅炉卡具及机炉电零配件等，公司在发展中，不断健全管理体系，完善管理手段，通过了三体系认证，且消防产品均有配套3c标签，确保客户消防验收合格。
              </p>-->
                        </div>
                    </div>
                    <!-- <div class="bottom" v-if="homeInfo.news.length!=0">
            <div class="left">
              <div class="more" @click="toGg">
                <span>{{homeInfo.news[0].name?homeInfo.news[0].name:""}}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="news">
                <div class="news_l" @click="tonewsInfo(homeInfo.news[0].news[0].id)">
                  <img :src="adddom(homeInfo.news[0].news[0].thumb)" alt />
                  <span>{{homeInfo.news[0].news[0].title}}</span>
                </div>
                新闻资讯
                <div class="news_r">
                  <div
                    class="news_rcon"
                    v-for="(item,index) in newsList"
                    :key="index"
                    @click="tonewsInfo(item.id)"
                  >
                    <div class="news_rpic">
                      <img :src="adddom(item.thumb)" alt />
                    </div>
                    <div class="newsInfo">
                      <span class="title">{{item.title}}</span>
                      <span class="newsCon slh">{{item.desc}}</span>
                      <span class="time">{{item.created_at}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            行业新闻
            <div class="right">
              <div class="more" @click="toGg">
                <span>{{homeInfo.news[1].name}}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="hangye">
                <div
                  class="hy_box"
                  v-for="(item,index) in homeInfo.news[1].news"
                  :key="index"
                  @click="tonewsInfo(item.id)"
                >
                  <span class="title">{{item.title}}</span>
                  <span class="hangCon slh">{{item.desc}}</span>
                </div>
              </div>
            </div>
          </div> -->
                </div>
            </div>
            <!-- 产品系列中心 -->
            <!-- <div class="product inner">
        <h3>产品系列中心</h3>
        <span class="des">打造世界知名品牌 成就国际优秀企业</span>
        <div class="pro_pic">


          //<a href="" onclick="openJesongChatByGroup(27963,57469); return false;"></a>


          <div class="pic" v-for="(item,index) in homeInfo.goods_cate" :key="index" @click="toChan(index)">
            <img class="bigPic" :src="adddom(item.thumb)" alt />
          </div>
        </div>
      </div> -->

            <div class="product_zx">
                <!-- 总导航 -->
                <div class="allnav inner">
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane v-for="(item,index) in cateList" :key="index" :label="item.text"
                            :name="index.toString()"></el-tab-pane>
                        <!-- <el-tab-pane label="电厂系列产品" name="second"></el-tab-pane>
                        <el-tab-pane label="电厂系列产品2" name="second2"></el-tab-pane> -->
                    </el-tabs>
                </div>
                <!-- 子导航 -->
                <div class="chanpincon">
                    <div class="inner">
                        <div class="childnav">
                            <div class="desc">
                                <img src="/statics/images/info/icon.png" alt />
                                <span>产品列表</span>
                            </div>
                            <el-tabs :tab-position="tabPosition" v-model="activeChildname" @tab-click="childHandleClick"
                                v-if="cateList.length!=0">
                                <!-- :label="item.text" -->
                                <el-tab-pane v-for="(item,index) in cateList[cateChild].children" :key="index"
                                    :name="item.value.toString()">
                                    <!-- <a href="" slot="label"
                                        :class="item.value==28?'rfsb' :''">{{item.text}}</a> -->
                                        <div slot="label" :class="item.value==28?'rfsb textaa' :'textaa'">{{item.text}}</div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <div class="cp_right">
                            <!-- 产品列表 -->
                            <div class="cp_list">
                                <div class="cp_item" v-for="(item,index) in goodsList" :key="index"
                                    @click="toCp_info(item.id)">
                                    <div class="pic">
                                        <img :src="adddom(item.thumb)" alt />
                                    </div>
                                    <div class="title">
                                        <span>{{item.name}}</span>
                                    </div>
                                    <div class="more">
                                        <span>查看详情</span>
                                        <i class="el-icon-arrow-right"></i>
                                    </div>
                                </div>
                            </div>
                            <!-- 分页 -->
                            <div class="fenye clearfix" v-if="goodsList.length!=0">
                                <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
                                    :page-size="pages.size" layout="prev, pager, next, jumper" :total="goodsTotal"
                                    prev-text="上一页" next-text="下一页"></el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 最适合的系统解决方案 -->
            <!-- <div class="solution">
        <div class="inner">
          <div class="left">
            <h3>合理有效的解决方案</h3>
            <div class="des">
              <span>为您提供全套的系统解决方案</span>
            </div>
            <div class="btn">
              <span :class="faIndex == 0?'act':''" @click="changeFa(0)">通风解决方案</span>
              <span :class="faIndex == 1?'act':''" @click="changeFa(1)">电厂解决方案</span>
            </div>
            <div class="onepic">
              <img src="/statics/images/index/sol_pic1.jpg" alt />
            </div>
            <div class="twopic">
              <img src="/statics/images/index/sol_pic2.jpg" alt />
              <img src="/statics/images/index/sol_pic3.jpg" alt />
            </div>
          </div>
          <div class="right">
            <img src="/statics/images/index/sol_pic4.jpg" alt />
            <img src="/statics/images/index/sol_pic5.jpg" alt />
          </div>
        </div>
      </div> -->
            <!-- <div class="quality inner">
        <h3>质量保障体系</h3>
        <div class="des">
          <span>打造世界知名品牌 成就国际优秀企业</span>
        </div>
        <div class="hang">
          <div class="ban">
            <span class="title">质量保障体系</span>
            <span class="english">Quality assurance system</span>
            <span class="des">德州润邦环保设备有限公司为您提供全套的系统解决方案</span>
          </div>
          <div class="ban">
            <img src="/statics/images/index/qua_pic1.jpg" alt />
          </div>
        </div>
        <div class="hang">
          <div class="ban">
            <img src="/statics/images/index/qua_pic2.jpg" alt />
          </div>
          <div class="ban">
            <span class="title">先进试验室</span>
            <span class="english">National Laboratory</span>
            <span class="des">德州润邦环保设备有限公司为您提供全套的系统解决方案</span>
          </div>
        </div>
        <div class="hang">
          <div class="ban">
            <span class="title">服务保障体系</span>
            <span class="english">Service guarantee system</span>
            <span class="des">完善的运营服务保障平台及全国各地办事网络综合体系</span>
          </div>
          <div class="ban">
            <img src="/statics/images/index/qua_pic3.png" alt />
          </div>
        </div>
      </div> -->
        </div>
        <!-- bottom -->
        <!-- <index-bottom></index-bottom> -->
        <!-- footer -->
        <index-footer></index-footer>
    </div>
</template>

<script>
    import indexNav from "./../components/nav";
    import indexBottom from "./../components/bottom";
    import indexFooter from "./../components/footer";
    // import homeData from "./../api/m/home.json";
    export default {
        name: "home",
        data() {
            return {
                faIndex: 0,
                swiper: "",
                newsList: [],
                // homeInfo: homeData.result, //首页详情
                homeInfo: {}, //首页详情
                // bannerList: [
                //   require("../../public/statics/images/index/banner.jpg"),
                //   require("../../public/statics/images/index/banner.jpg"),
                //   require("../../public/statics/images/index/banner.jpg")
                // ]
                // 产品中心
                activeName: "0", //总导航
                cateList: [], //产品分类
                tabPosition: "left", //子导航对齐方式
                activeChildname: "", //子导航
                goodsList: [], //产品列表
                currentPage: 1, //当前页数
                goodsTotal: 0, //总条数
                cateChild: 0,
                cateId: "",
                pages: {
                    page: 1,
                    size: 9
                },
            };
        },
        components: {
            indexNav,
            indexBottom,
            indexFooter
        },
        created() {
            // console.log(this.$publicData)
            // console.log('homeData.result:',homeData.result)
            // this.homeInfo = homeData.result
            this.getIndex();
            this.getCate();//产品中心分类
        },
        methods: {
            changeFa(num) {
                this.faIndex = num;
            },
            // 点击跳转到新闻资讯详情
            tonewsInfo(id) {
                this.$router.push({
                    path: "/news_zxinfo",
                    query: {
                        id: id
                    }
                });
            },
            toInfo() {
                this.$router.push({
                    path: "/jt_survey"
                });
            },
            toChan(index) {
                this.$router.push({
                    path: "/product_zx",
                    query: {
                        num: index
                    }
                });
            },
            // 点击公告
            toGg() {
                this.$router.push({
                    path: "/news_zx"
                });
            },
            // 图片拼接地址
            adddom(src) {
                if (src == "" || src == undefined || src == null) {
                    console.log("src地址有问题");
                    return "";
                }
                if (src.substr(0, 4).toLowerCase() === "http") {
                    return src;
                }
                return this.$url + src;
            },
            getIndex() {
                var that = this;
                that.$api.index.index({}).then(function (res) {
                    if (res.code == 200) {
                        that.homeInfo = res.result;
                        that.newsList = res.result.news[0].news.slice(1);
                    }
                });
            },
            // 产品中心
            // 总导航选中触发
            handleClick(tab, event) {
                // console.log(tab.name);
                var that = this;
                that.activeName = tab.name;
                that.cateChild = tab.name;
                if (that.cateList && that.cateList[that.cateChild].children) {
                    that.activeChildname = that.cateList[
                        that.cateChild
                    ].children[0].value.toString();
                    that.cateId = that.activeChildname;
                    that.pages.page = 1;
                    that.getList();
                } else {
                    that.goodsList = [];
                }
            },
            // 子导航选中触发
            childHandleClick(tab, event) {
                // console.log(tab.name);
                this.cateId = tab.name;
                this.pages.page = 1;
                this.goodsList = [];
                this.getList();
            },
            getCate() {
                var that = this;
                that.$api.index.goodsCate({}).then(function (res) {
                    if (res.code == 200) {
                        that.cateList = res.result;
                        if (that.cateList && that.cateList[that.cateChild].children) {
                            that.activeChildname = that.cateList[
                                that.cateChild
                            ].children[0].value.toString();
                            that.cateId = that.activeChildname;
                            that.pages.page = 1;
                            that.getList();
                        } else {
                            that.goodsList = [];
                        }
                    }
                });
            },
            //产品列表
            getList() {
                var that = this;
                var ps = {
                    cate_id: that.cateId,
                    page: that.pages.page,
                    size: that.pages.size
                };
                that.$api.index.goodsList(ps).then(function (res) {
                    if (res.code == 200) {
                        that.goodsList = res.result.list;
                        that.goodsTotal = res.result.total;
                    }
                });
            },
            // 页数改变时触发
            handleCurrentChange(val) {
                // console.log(val);
                this.pages.page = val;
                this.getList();
            },
            // 跳转到产品中心详情
            toCp_info(id) {
                this.$router.push({
                    path: "/product_zxinfo",
                    query: {
                        cate: this.cateChild,
                        id: id
                    }
                });
            },
        },
        updated() {
            this.swiper = new Swiper(".mySwiper", {
                loop: true,
                // autoplay: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false //true触碰后停止自动切换
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction"
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            });
            // this.swiper.update();
        },
        mounted: function () {
            // this.swiper = new Swiper(".mySwiper", {
            //   loop: true,
            //   autoplay: true,
            //   // autoplay: {
            //   //   delay: 2500,
            //   //   disableOnInteraction: false //true触碰后停止自动切换
            //   // },
            //   pagination: {
            //     el: ".swiper-pagination",
            //     type: "fraction"
            //   },
            //   navigation: {
            //     nextEl: ".swiper-button-next",
            //     prevEl: ".swiper-button-prev"
            //   }
            // });
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    html,
    body {
        position: relative;
        height: 100%;
    }

    body {
        background: #eee;
        font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
        font-size: 14px;
        color: #000;
        margin: 0;
        padding: 0;
    }

    .lunbo {
        max-width: 2000px;
        margin: 0 auto;
        height: 714px;
    }

    .swiper {
        width: 100%;
        height: 100%;
        /* min-height: 714px; */
        overflow: hidden;
        position: relative;
    }

    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }

    .swiper-slide a {
        width: 100%;
    }

    .swiper-slide img {
        width: 100%;
        /* height: auto; */
        /* min-width: 1200px; */
        height: 714px;
        /* display: block;
  object-fit: cover; */
    }

    .swiper-pagination-fraction {
        top: 70%;
        left: 6%;
        text-align: left;
        font-size: 16px;
        color: #fff;
        width: 10%;
        text-align: center;
    }

    /deep/.swiper-pagination-current {
        font-size: 40px;
        color: #fff;
        margin-right: 5px;
    }

    .swiper-button-prev::after {
        font-size: 20px;
    }

    .swiper-button-next::after {
        font-size: 20px;
    }

    .swiper-button-prev {
        top: 70%;
        left: 5%;
        color: #fff;
        margin: 0;
        height: 70px;
        z-index: 100;
    }

    .swiper-button-next {
        top: 70%;
        left: 15%;
        color: #fff;
        margin: 0;
        height: 70px;
        z-index: 100;
    }
</style>